import { render, staticRenderFns } from "./ywyjxjs.vue?vue&type=template&id=28ed1099&scoped=true&"
import script from "./ywyjxjs.vue?vue&type=script&lang=js&"
export * from "./ywyjxjs.vue?vue&type=script&lang=js&"
import style0 from "./ywyjxjs.vue?vue&type=style&index=0&id=28ed1099&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ed1099",
  null
  
)

export default component.exports